import api from '@/utils/api';
import {Commit} from "vuex";

const state = {};
const mutations = {};

const getters = {};
const actions = {

  // 用户文件告警列表
  async api_file_trace_query_file(_commit, params) {
    return api.post('/api/file_trace/query_file', params);
  },
  async api_file_trace_query_file_detail(_commit, params) {
    return api.post('/api/file_trace/query_file_detail', params);
  },
  async api_file_trace_file_detail_report(_commit, params) {
    return api.post('/api/file_trace/file_detail_report', params);
  },
  // 查看他人文件流转申请记录
  async api_file_trace_apply_check_save(_commit, params) {
    return api.post('/api/file_trace/apply_check/save_apply', params);
  },
  async api_file_trace_apply_check_list(_commit, params) {
    return api.post('/api/file_trace/apply_check/list_apply', params);
  },
  async api_file_trace_apply_check_delete(_commit, params) {
    return api.post('/api/file_trace/apply_check/delete_apply', params);
  },
  // 查询他人文件流转记录
  async api_file_trace_other_file_list(_commit, params) {
    return api.post('/api/file_trace/apply_check/list_other_file_trace_files', params);
  },
  async api_file_trace_other_detail_list(_commit, params) {
    return api.post('/api/file_trace/apply_check/list_other_file_trace_file_detail', params);
  },
  // 用户自定义设置
  async api_file_trace_query_user_setting(_context: { commit: Commit }) {
    return api.post('/api/file_trace/apply_check/selectUserSetting')
  },
  async api_file_trace_submit_user_setting(_context: { commit: Commit }, params: any) {
    return api.post('/api/file_trace/apply_check/saveUserSetting', params)
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};
